import styled from "styled-components";

const PaxInfoContainer = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 32px;
    height: 32px;
  }
`;

export default PaxInfoContainer;
